import { subscribeToEvent } from '../tools/event-subscribe';

export function mouseSpeedCollector(onData) {
  let startTime = null,
    lastTime = null,
    D = 0;
  const allStartTime = Date.now();

  const data = [];

  /**
     *
     * @param {MouseEvent} e
     */
  function handleMouseMove(e) {
    if (lastTime && lastTime + 200 < e.timeStamp) {
      if (D) {
        const d = D,
          t = lastTime - startTime,
          v = d / t * 1000 * 60;
        const allTime = Date.now() - allStartTime;
        const f = (data.length + 1) / allTime * 1000 * 60;
        const move = {
          d, t, v, f,
        };
        data.push(move);
        onData(move);
      }
      startTime = lastTime = null;
      D = 0;
    }

    if (!startTime) {
      startTime = e.timeStamp - 30;
    } else {
      const { movementX, movementY } = e;

      D += Math.sqrt(Math.pow(movementX, 2) + Math.pow(movementY, 2));
    }

    lastTime = e.timeStamp;
  }

  const subscriptions = [
    subscribeToEvent(window, 'mousemove', handleMouseMove, { capture: true }),
  ];

  function stop() {
    subscriptions.forEach(u => u());
  }

  function toString() {
    if (data.length) {
      const {
        d, t, v, f,
      } = data.reduce((p, c) => ({
        d: p.d + c.d,
        t: p.t + c.t,
        v: p.v + c.v,
        f: p.f + c.f,
      }));
      const count = data.length;
      const avg = {
        d: d / count,
        t: t / count,
        v: v / count,
        f: f / count,
      };

      return `${Math.round(avg.d)}|${Math.round(avg.t)}|${Math.round(avg.v)}|${Math.round(avg.f)}|${data.length}`;
    }
    return '';
  }

  return {
    data,
    toString,
    stop,
  };
}



// WEBPACK FOOTER //
// ./src/lib/collectors/mouse-speed.js